<a class="link d-flex justify-content-center flex-column"
  [routerLink]="['/search', 'card']"
  [queryParams]="{id: contributor.id, entityType: 'Agent'}"
  tabindex="0"
  data-automation-id="link-to-contributor"
  [attr.data-focus-id]="'id' + index"
  #item>
  <div class="image-container">
    <app-cover
      [config]="coverConfig"
      data-automation-id="contributor-image"
      size="large">
    </app-cover>
  </div>
  <ng-container *ngIf="contributor.label">
    <div class="cdk-visually-hidden" aria-hidden="true">{{ contributor.label }}</div>
    <h4 class="title mt-5 line-clamp line-clamp--two"
      [tippy]="contributor.label"
      data-automation-id="contributor-name">
      {{ contributor.label }}
    </h4>
  </ng-container>
  <div *ngIf="contributor?.relationshipTypes?.length"
    class="author mt-4"
    data-automation-id="contributor-relationship-types">
    <span>{{ contributorRoles }}</span>
  </div>
  <div class="year mt-1"
    translate [translateParams]="{ value: contributor.resourceLinksCount }"
    data-automation-id="contributor-related-resources-count">
    relatedResourceCounter
  </div>
</a>
